export enum Resources {
    External = 'external',
    ImpactVideo = 'impact-video'
}